import { render } from "./assinaTermo.vue?vue&type=template&id=0b2e0ce9&scoped=true"
import script from "./assinaTermo.vue?vue&type=script&lang=js"
export * from "./assinaTermo.vue?vue&type=script&lang=js"

import "./assinaTermo.vue?vue&type=style&index=0&id=0b2e0ce9&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2e0ce9"]])

export default __exports__